import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    isolation: 'isolate',
    pointerEvents: 'none',
    margin: 0,
    padding: theme.spacing(1, 2),
    boxSizing: 'border-box',
    fontSize: 14,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

export default useStyles;
